import api from "@/assets/scripts/api";
import { compress } from "@/assets/scripts/features";
import { base64toFile } from "@/assets/scripts/utils";
import http from "@/plugins/http";
// 按照行数获取文字样式
export const genSizeAndTextInfo = (sizeInfo, fontStyles, fontId) => {
  const {
    id,
    marginTop,
    offsetX,
    offsetY,
    remainPart,
    textAlignType,
    textPositionX,
    textPositionY,
    elementHeight,
    elementWidth,
    width,
    height,
    sizeName,
  } = sizeInfo;
  const elementInfo = {
    elementHeight,
    elementWidth,
    offsetX,
    offsetY,
    remainPart,
  };
  const size = {
    width,
    height,
  };
  const styles = [];
  for (let x = 0; x < fontStyles.length; x++) {
    const s = fontStyles[x];
    const defaultMarginTop = x === 0 ? 0 : 8;
    styles[x] = {
      marginTop: marginTop || defaultMarginTop,
      ...s,
      i: x,
      labelStyle: "样式1",
      showLabelStyle: false,
    };
  }
  const textInfo = {
    textAlignType,
    textPositionX,
    textPositionY,
    textCountLimit: [],
  };
  return {
    elementInfo,
    size,
    textInfo,
    sizeId: id || 0,
    sizeName: sizeName || "",
    textStyleId: fontId,
    textStyle: styles || [],
  };
};
export const onUpload = async (imgBase64Data, uploadUrl) => {
  // 图片压缩
  const formData = new FormData();
  for (var key of formData.keys()) {
    formData.delete(key);
  }
  formData.append(
    "banner",
    base64toFile(
      imgBase64Data,
      Math.random().toString(36).slice(-8) // 随机生成名字
    )
  );
  let { data } = await compress(formData);
  const imgUrl = `//bar.xkw.com${data.result}`;
  // 向父页面传递图片生成结果
  parent && parent.postMessage(imgUrl, uploadUrl);
};
export const getUserCovers = async (params) => {
  const { data } = await http.get(api.userDesigns, params);
  for (let coverMap of data.list) {
    const { fontStyles } = coverMap;
    fontStyles.forEach((textMap) => {
      textMap.isShowText = !!textMap.text;
      textMap.isMainTitle =
        /Heavy|Black/.test(textMap.fontFamily) && !textMap.isLabelStyle;
    });
  }
  return data;
};
